import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { allServices } from "../../data/services";
import "./Bookings.css";

const Bookings = () => {
  const location = useLocation();
  const [selectedService, setSelectedService] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);

  // Handle pre-selected service from Services page
  useEffect(() => {
    if (location.state?.preselectedService) {
      const preselected = allServices.find(
        (service) => service.name === location.state.preselectedService
      );
      if (preselected) {
        setSelectedService(preselected);
        // Scroll to date selection
        setTimeout(() => {
          const dateSection = document.querySelector(
            ".booking-step:nth-child(2)"
          );
          if (dateSection) {
            dateSection.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }, 300);
      }
    }
  }, [location.state]);

  const services = allServices;

  // Generate next 7 available dates
  const getAvailableDates = () => {
    const dates = [];
    const today = new Date();
    for (let i = 1; i <= 7; i++) {
      const date = new Date(today);
      date.setDate(today.getDate() + i);
      dates.push(date);
    }
    return dates;
  };

  // Available time slots
  const timeSlots = [
    "9:00 AM",
    "10:00 AM",
    "11:00 AM",
    "1:00 PM",
    "2:00 PM",
    "3:00 PM",
    "4:00 PM",
  ];

  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };

  const handleBooking = () => {
    // Handle booking submission
    console.log("Booking submitted:", {
      selectedService,
      selectedDate,
      selectedTime,
    });
  };

  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  return (
    <div className="bookings-page">
      <motion.div
        className="bookings-container"
        initial="initial"
        animate="animate"
        variants={fadeIn}
      >
        <div className="bookings-header">
          <h1>Book Your Treatment</h1>
          <div className="header-divider"></div>
          <p>Select your preferred treatment, date, and time</p>
          {location.state?.preselectedService && (
            <div className="preselected-badge">
              <span className="badge-icon">✓</span>
              <span>Service selected: {location.state.preselectedService}</span>
            </div>
          )}
        </div>

        <div className="booking-steps">
          <div className="booking-step">
            <h2>1. Select Treatment</h2>
            <div className="services-grid">
              {services.map((service) => (
                <motion.div
                  key={service.id}
                  className={`service-card ${
                    selectedService?.id === service.id ? "selected" : ""
                  }`}
                  onClick={() => setSelectedService(service)}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                  <div className="service-details">
                    <span>{service.duration}</span>
                    <span>{service.price}</span>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {selectedService && (
            <div className="booking-step">
              <h2>2. Choose Date</h2>
              <div className="dates-grid">
                {getAvailableDates().map((date, index) => (
                  <motion.div
                    key={index}
                    className={`date-card ${
                      selectedDate?.toDateString() === date.toDateString()
                        ? "selected"
                        : ""
                    }`}
                    onClick={() => setSelectedDate(date)}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {formatDate(date)}
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {selectedDate && (
            <div className="booking-step">
              <h2>3. Select Time</h2>
              <div className="times-grid">
                {timeSlots.map((time, index) => (
                  <motion.div
                    key={index}
                    className={`time-card ${
                      selectedTime === time ? "selected" : ""
                    }`}
                    onClick={() => setSelectedTime(time)}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    {time}
                  </motion.div>
                ))}
              </div>
            </div>
          )}

          {selectedService && selectedDate && selectedTime && (
            <motion.div
              className="booking-summary"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              <h2>Booking Summary</h2>
              <div className="summary-details">
                <p>
                  <strong>Treatment:</strong> {selectedService.name}
                </p>
                <p>
                  <strong>Date:</strong> {formatDate(selectedDate)}
                </p>
                <p>
                  <strong>Time:</strong> {selectedTime}
                </p>
                <p>
                  <strong>Duration:</strong> {selectedService.duration}
                </p>
                <p>
                  <strong>Price:</strong> {selectedService.price}
                </p>
              </div>
              <button className="confirm-booking" onClick={handleBooking}>
                Confirm Booking
              </button>
            </motion.div>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default Bookings;
